export const NAVIGATION_HEIGHT = 70;
export const NAVIGATION_HEIGHT_MOBILE = 55;
export const GLOBAL_NAV_HEIGHT = 55;

export const URL_REGEX =
  /((https?):\/\/)?(www.)?[a-z0-9-]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9#-_]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/;

export const STRIPE_PUBLISHABLE_KEY = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;

// Feature flags
export const FEATURE_AMBASSADOR_DASHBOARD_NI_THREE =
  process.env.REACT_APP_FEATURE_AMBASSADOR_DASHBOARD_NI_THREE === 'true';

export const FEATURE_CREDITS = process.env.REACT_APP_FEATURE_CREDITS === 'true';
